"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapFrequencyDeliveryOptions = exports.mapDaysToWeeks = exports.doesTranslationExist = void 0;
const doesTranslationExist = (key, translations) => key in translations;
exports.doesTranslationExist = doesTranslationExist;
const mapDaysToWeeks = (days, translations) => {
  const translationKey = days > 0 ? `every${days / 7}Week` : '';
  if (doesTranslationExist(translationKey, translations)) {
    return translations[translationKey];
  }
  return '';
};
exports.mapDaysToWeeks = mapDaysToWeeks;
const mapFrequencyDeliveryOptions = ({
  deliveryFrequencyOptions,
  recommendedFrequency,
  translations
}) => deliveryFrequencyOptions.map(value => {
  const label = mapDaysToWeeks(value, translations);
  return {
    value,
    label: value === recommendedFrequency && label !== '' ? `${label} (${translations.recommended})` : label
  };
}).filter(({
  label
}) => label !== '');
exports.mapFrequencyDeliveryOptions = mapFrequencyDeliveryOptions;
